import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import AssessmentRecordsPage from "./Report";
import VendorReport from "./VendorReport";
import { motion } from "framer-motion";
import StudentReport from "./StudentReport";

const StudentConductedReportsTab = () => {
    const [activeTab, setActiveTab] = useState("own"); // 'own' selected by default
    const [showModal, setShowModal] = useState(false);

    const userType = localStorage.getItem("userType");
    return (
        <div className="min-h-screen bg-gradient-to-br from-white to-gray-50 p-6">
            <motion.div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between px-4 md:px-0"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
            >
                <div className="flex items-center justify-center max-md:justify-start md:justify-start gap-2 max-md:ml-6 px-6 max-md:px-0">
                    <h2 className="text-2xl font-bold text-gray-800">Conducted Result</h2>
                    <button
                        onClick={() => setShowModal(true)}
                        className="md:hidden"
                        aria-label="More info"
                    >
                        <FaInfoCircle
                            size={18}
                            className="text-gray-600 hover:text-blue-800 transition ml-4"
                        />
                    </button>
                </div>

            </motion.div>

            {activeTab === "own" && <StudentReport reportType="own" />}

            {showModal && (
                <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
                    <div className="relative bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md">

                        {/* Cross button */}
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-4 right-4 text-black hover:text-gray-600"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>

                        {/* Dynamic content based on tab */}
                        <>
                            <h3 className="text-lg font-semibold mb-2">Own Report Info</h3>
                            <p className="text-sm text-gray-700">
                                Your assessment results and history will be available here once completed
                            </p>
                        </>
                    </div>
                </div>
            )}
        </div >
    )
}

export default StudentConductedReportsTab